var filterAnchorableBlocks=function(array,filter){return array.filter((function(block){return block.anchorType===filter}))};export{filterAnchorableBlocks};
//# sourceMappingURL=anchorUtils.js.map
